module.exports = __webpack_public_path__ + "img/1.cffaa7d1.png";